// extracted by mini-css-extract-plugin
module.exports = {"Videosection":"Videosection_Videosection__1Fzh-"};